'use strict';

(function($) {

    var pluginName = 'kumsalForm';

    // plugin setup
    $.fn[pluginName] = function(options) {
        if ($(this).length === 0) {
            return;
        }

        // global variables
        var form = this;


        var Plugin = {
            isInit: false,
            form: null,
            send: function(){

                swal.fire({
                    icon: 'info',
                    title: Translation.form.loading.title,
                    html: Translation.form.loading.description,
                    onBeforeOpen: function(){
                        swal.showLoading();
                    },
                    allowOutsideClick: function(){
                        return !swal.isLoading();
                    },
                });

                $.ajax({
                    url: $(form.form).attr('action'),
                    type: $(form.form).attr('method'),
                    data: new FormData(form.form),
                    processData: !1,
                    contentType: !1
                }).always(function(response) {


                    if(typeof response.status === 'boolean' && response.status)
                    {
                        swal.fire({
                            icon: 'success',
                            title: Translation.form.success.title,
                            html: typeof response.message === 'string' ? response.message :  Translation.form.success.description,
                            confirmButtonText: Translation.form.buttons.okey,
                        });
                        form.form.reset();
                    }
                    else if(typeof response.status === 'number' && response.status === 422)
                    {
                        try
                        {
                            var errors = [];
                            var message = Translation.form.failed.description;

                            $.each(Object.entries(response.responseJSON.errors), function( index, value ) {
                                errors = errors.concat(value[1]);
                            });

                            message = errors.join('<br>');
                        }catch (e) {}

                        swal.fire({
                            icon: 'error',
                            title: Translation.form.failed.title,
                            html: message,
                            confirmButtonText: Translation.form.buttons.okey,
                        });

                    }
                    else
                    {
                        swal.fire({
                            icon: 'error',
                            title: Translation.form.failed.title,
                            html: Translation.form.failed.description,
                            confirmButtonText: Translation.form.buttons.okey,
                        });
                    }

                });
            },
            changeFile: function(file){
                var fileName = '';

                for (var i = 0; i < $(file).get(0).files.length; ++i) {
                    fileName = fileName + $(file).get(0).files[i].name.split(/(\\|\/)/g).pop() + (i != ($(file).get(0).files.length - 1) ? ' || ' : '');
                }
                var label = $(file).next('.custom-file-label-kumsal');

                label.html(fileName);
                fileName === '' ?
                    label.removeClass('selected') :
                    label.addClass('selected');
            },
            initFile: function(){

                form.find('.kumsal-form-file').each(function () {
                    $(this).on('change',function(){
                        form.changeFile(this);
                    });

                    form.changeFile(this);
                });
            },
            initSelect: function(){

                form.find('.kumsal-form-select').each(function () {
                    $(this).select2({
                        language: $('html').attr('lang'),
                        //minimumResultsForSearch: $(this)[0].hasAttribute('data-search') ? 1 : Infinity,
                    });/*
                    $(this).on('select2:opening select2:closing', function( event ) {
                        var $searchfield = $(this).parent().find('.select2-search__field');
                        $searchfield.prop('disabled', true);
                    });*/
                });
            },
            initDateTime: function(){


                form.find('.kumsal-form-datetime').each(function () {
                    $(this).datetimepicker({
                        todayHighlight: true,
                        autoclose: true,
                        format: 'yyyy-mm-dd hh:ii',
                        language: $('html').attr('lang'),
                    });
                });
            },
            resetEvent:function(){
                form.find('input[type=file]').val(null).trigger('change');
                form.find('.kumsal-form-select').val('').trigger('change');
            },
            init: function() {

                if (!form.isInit && form.attr('data-ajax') !== 'false')
                {
                    form.submit(function () {
                        form.form = this;
                        form.send();

                        return false;
                    });

                    form.isInit = true;
                }

                if (form.find('.kumsal-form-file').length)
                {
                    form.initFile();
                }

                if (form.find('.kumsal-form-select').length)
                {
                    form.initSelect();
                }

                if (form.find('.kumsal-form-datetime').length)
                {
                    form.initDateTime();
                }

                form.on('reset',function () {
                    form.resetEvent();
                });

                return form;
            },
        };

        /**
         * Public API methods can be used directly by datatable
         */
        $.each(Plugin, function(funcName, func) {
            form[funcName] = func;
        });

        if (!form.isInit){
            form.init();
        }

        return form;
    };

    if ($('.kumsal-form').length)
    {
        $('.kumsal-form').kumsalForm();
    }


}(jQuery));

